import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentsFetchFailedAction = {
	type: 'DOCUMENTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentsFetchFailedAction => ({
	type: 'DOCUMENTS_FETCH_FAILED',
	payload,
});
